<!-- event-lesson-entity.component.html -->
<app-entity-mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle title="Lesson"></app-entity-mat-dialog-title>

<div [ngClass]="{
        'loading-shade': showProgressSpinner,
        'shade-locked': isEventLocked
     }">

    <div mat-dialog-content>

        <mat-progress-spinner class="matProgressSpinnerCentered"
            *ngIf="showProgressSpinner" mode="indeterminate">
        </mat-progress-spinner>

        <mat-icon aria-hidden="false" class="lockIconCentered"
            *ngIf="isEventLocked">lock</mat-icon>

        <mat-tab-group class="eventTabGroup"
            [selectedIndex]="this.selectedIndex"
            (selectedTabChange)="setFormMode($event.index)"
            animationDuration="0ms" #tabs>

            <mat-tab label="View" [disabled]="this.initActionType == 'create'">
                <app-entity-mat-tab-view [entityData]="entityData"></app-entity-mat-tab-view>
            </mat-tab>

            <mat-tab
                label="{{(this.initActionType == 'create' ? 'Create' : 'Edit')}}">
                <app-error-message [message]=this.errorMessage></app-error-message>

                <!-- Form -->
                <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
                    <div class="container">

                        <div class="row">

                            <div class="col-12 mt-1">
                                <input
                                    class="d-none"
                                    type="text"
                                    [(ngModel)]="field_student"
                                    name="field_student"
                                    value="{{studentList}}">

                                <div class="pi-card mat-elevation-z1">
                                    <div class="pi-header">
                                        <div>
                                            <div class="pi-title">Attendees</div>
                                            <div class="pi-subtitle">Select student account, contact, and enrollment.</div>
                                        </div>
                                    </div>

                                    <!-- Attendees list -->
                                    <div class="pi-section" *ngIf="!editMode">
                                        <app-display-attendees
                                            [field_students]="field_student"
                                            [studentUpdateLoad]="studentUpdateLoad"
                                            [studentRemove]="studentRemove"
                                            [editMode]="editMode"></app-display-attendees>
                                    </div>

                                    <div
                                        [ngClass]="{ 'd-none': (this.objLength(field_student) > 0) && !this.editMode }"
                                        class="pi-form attendee-form-card"
                                        ngModelGroup="__field_students_inline_form"
                                        #attendee="ngModelGroup"
                                        [@slideFade]
                                        [@.disabled]="false">

                                        <input class="d-none" ngModel name="id" matInput>
                                        <input class="d-none" [ngModel]="entityType" name="type" matInput>
                                        <input class="d-none" [ngModel]="entityBundle" name="bundle" matInput>

                                        <div class="pi-form-grid">
                                            <!-- Student Account Autocomplete -->
                                            <div class="pi-field">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>Student Account</mat-label>
                                                    <input
                                                        name="field_student_account"
                                                        (input)="onAutocompleteStudent($event); onStudentAccountInput(td_student_account.value)"
                                                        matInput
                                                        ngModel
                                                        (ngModelChange)="onStudentAccountInput($event);"
                                                        #td_student_account
                                                        [matAutocomplete]="autoCompleteStudentAccount">
                                                    <button type="button"
                                                        matSuffix
                                                        mat-icon-button
                                                        aria-label="manage_accounts">
                                                        <mat-icon>manage_accounts</mat-icon>
                                                    </button>
                                                    <mat-error *ngIf="studentAccountFormatError">
                                                        Please select a student account from the dropdown list
                                                    </mat-error>
                                                </mat-form-field>
                                                <mat-autocomplete
                                                    #autoCompleteStudentAccount="matAutocomplete"
                                                    (optionSelected)="studentAccountFormatError = false; lookupStudentAccountContact($event, true); onStudentNameSelectThenLoadEnrollmentNameLESSONS($event, false, this?._frmValues?.field_student?.[0]?.field_enrollment, true, 'createLesson', f.value.field_type );">
                                                    <mat-option
                                                        *ngFor="let option of autoCompleteStudentOptions"
                                                        [value]="option.label + ' (' + option.value + ')'">
                                                        {{option.label}}
                                                        ({{option.value}})
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </div>

                                            <div class="pi-field" *ngIf="objLength(autoCompleteStudentContactOptions) > 0">
                                                <label class="pi-label"
                                                    >Students<sup>*</sup></label>
                                                <div class="pi-radio-wrap">
                                                    <mat-radio-group
                                                        ngModel
                                                        name="field_students"
                                                        class="radio-group"
                                                        aria-label="Select an option">
                                                        <mat-radio-button
                                                            class="pi-radio"
                                                            *ngFor="let contact of autoCompleteStudentContactOptions"
                                                            [value]="contact['id']">
                                                            {{ contact['title'] }}
                                                        </mat-radio-button>
                                                    </mat-radio-group>
                                                </div>
                                            </div>

                                            <!-- Enrollment Dropdown -->
                                            <div class="pi-field">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>Enrollment Name</mat-label>
                                                    <mat-select
                                                        matInput
                                                        ngModel
                                                        name="field_enrollment"
                                                        (selectionChange)="lessonTypeManuallySelected = false; validateEnrollment('_none', td_student_account.value, enrollment_id.value)"
                                                        #enrollment_id>
                                                        <mat-select-trigger>
                                                            <ng-container *ngIf="getEnrollmentById(enrollment_id.value) as selected">
                                                                {{ selected.title[0]?.value }}
                                                                (Avail:
                                                                  <span [ngClass]="getNonUnitZeroClass(selected)">
                                                                    {{ selected.field_lesson_available[0]?.value }}
                                                                  </span>
                                                                  of {{ selected.field_enrollment_lesson_count[0]?.value }},
                                                                Due: {{
                                                                  selected.field_balance_due[0]?.value | studioCurrency
                                                                }})
                                                            </ng-container>
                                                        </mat-select-trigger>
                                                        <mat-option>None</mat-option>
                                                        <mat-option
                                                            *ngFor="let element of enrollmentsForUser"
                                                            [value]="element.id[0].value">
                                                            {{ element.title[0]?.value }}
                                                            (Avail:
                                                              <span [ngClass]="getNonUnitZeroClass(element)">
                                                                {{ element.field_lesson_available[0]?.value }}
                                                              </span>
                                                              of {{ element.field_enrollment_lesson_count[0]?.value }},
                                                            Due: {{
                                                              element.field_balance_due[0]?.value | studioCurrency
                                                            }})
                                                            <!-- (Lessons Available: 3, Price: $0.00, Paid: 0, Balance: 0) -->
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-hint *ngIf="coachingPackage && f?.value?.field_type == '1411'">
                                                        {{ coachingNoEnrollment
                                                            ? 'No ' + coachingPackage.name + ' enrollment for this student'
                                                            : 'Coaching: ' + coachingPackage.name + ' enrollments only' }}
                                                    </mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="pi-actions">
                                            <button *ngIf="!editMode"
                                                type="button"
                                                mat-raised-button
                                                [disabled]="!attendee.valid || studentAccountFormatError"
                                                class="me-1"
                                                color="primary"
                                                (click)="studentIncrement(attendee.value)">
                                                Add attendee
                                            </button>
                                            <button *ngIf="editMode"
                                                type="button"
                                                mat-raised-button
                                                [disabled]="!attendee.valid || studentAccountFormatError"
                                                class="me-1"
                                                color="primary"
                                                (click)="studentUpdateSubmit(i, attendee.value)">
                                                Edit Attendee
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-4">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Lesson Type</mat-label>
                                    <mat-select required ngModel
                                        name="field_type"
                                        (ngModelChange)="updateLessonDefaultTimes($event.value)"
                                        (selectionChange)="onLessonTypeManualChange(); validateEnrollment('_none', td_student_account.value, enrollment_id.value); updateLessonDefaultTimes($event.value); refreshEnrollmentsForLessonType($event.value, td_student_account.value)">
                                        <mat-option>None</mat-option>
                                        <mat-option
                                            *ngFor="let element of this._taxonomyService?.lesson_type"
                                            [value]="element.id">{{ element.name
                                            }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-12 col-sm-4">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Instructor</mat-label>
                                    <mat-select required [(ngModel)]="field_instructor"
                                        (ngModelChange)="checkScheduleConflicts()"
                                        name="field_instructor">
                                      <mat-option>None</mat-option>
                                      <ng-container *ngFor="let element of _fieldsService.instructorData(); let i = index">
                                        <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_instructor)"
                                                    [value]="element.uid">
                                          {{ element.value }}
                                          <ng-container *ngIf="element.status === '0' && element.uid === field_instructor"></ng-container>
                                        </mat-option>
                                      </ng-container>
                                      <!-- Web bookings start on the Website Booking service account; shown so the field is not blank until a teacher is picked. -->
                                      <ng-container *ngFor="let element of _fieldsService.systemUsers()">
                                        <mat-option *ngIf="element.uid === field_instructor" [value]="element.uid">{{ element.value }}</mat-option>
                                      </ng-container>
                                    </mat-select>
                                  </mat-form-field>
                            </div>

                            <div class="col-12 col-sm-4">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Duration</mat-label>
                                    <mat-select matInput ngModel
                                        (ngModelChange)="checkScheduleConflicts()"
                                        name="field_duration">
                                        <mat-option>None</mat-option>
                                        <mat-option
                                            *ngFor="let element of this._fieldsService.durations"
                                            [value]="element.value">
                                            {{ element.value }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-12">
                                <input class="d-none" type="text" name="field_date_and_time"
                                       [(ngModel)]="field_date_and_time"
                                       (ngModelChange)="onFieldDateAndTimeModelChange($event); checkScheduleConflicts();">

                                <!-- Landscape Mode: Calendar (col-6) + Time Picker (col-6) -->
                                <div [hidden]="!isLandscapeMode" class="row me-1">
                                    <!-- Calendar Column -->
                                    <div class="col-6 px-0">
                                        <div id="landscape-calendar-wrapper" [hidden]="!isLandscapeMode">
                                            <input #landscapeCalendarInput type="text" style="visibility: hidden; height: 0; width: 0; position: absolute;">
                                        </div>
                                    </div>

                                    <!-- Time Picker Column -->
                                    <div class="col-6 px-2">
                                        <!-- Scrollable Time Picker -->
                                        <div class="landscape-time-picker">
                                            <!-- Hour + Period Combined Selector -->
                                            <div class="time-section mb-3">
                                                <label class="time-label">Hour</label>
                                                <div class="time-buttons-scroll hour-period-scroll">
                                                    <button type="button"
                                                            *ngFor="let hourPeriod of hourPeriodOptions"
                                                            class="time-btn hour-period-btn"
                                                            [class.active]="landscapeHour === hourPeriod.hour && landscapePeriod === hourPeriod.period"
                                                            (click)="onLandscapeHourPeriodChange(hourPeriod.hour, hourPeriod.period)">
                                                        {{ hourPeriod.display }}
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Minute Selector -->
                                            <div class="time-section mb-3">
                                                <label class="time-label">Minute</label>
                                                <div class="time-buttons-scroll minute-scroll">
                                                    <button type="button"
                                                            *ngFor="let min of ['00', '15', '30', '45']"
                                                            class="time-btn"
                                                            [class.active]="landscapeMinute === min"
                                                            (click)="onLandscapeMinuteChange(min)">
                                                        {{ min }}
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Selected Time Display -->
                                            <div class="selected-time p-3 text-center" style="background: #f5f5f5; border-radius: 8px; font-weight: bold;">
                                                {{ landscapeHour }}:{{ landscapeMinute }} {{ landscapePeriod }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Non-Landscape Mode: Standard desktop/mobile pickers -->
                                <div [hidden]="isLandscapeMode" class="row">
                                    <div class="col-md-12 col-12">
                                        <ng-container *ngIf="!useMobileSplitPicker; else mobilePickers">
                                            <mat-form-field class="full-width-field">
                                                <mat-label>Choose a date</mat-label>
                                                <input #flatpickrInput matInput type="text"
                                                       [value]="flatpickrDisplayValue"
                                                       readonly>
                                                <button matSuffix mat-icon-button type="button" (click)="openFlatpickr()">
                                                    <mat-icon>calendar_today</mat-icon>
                                                  </button>
                                            </mat-form-field>
                                        </ng-container>
                                        <ng-template #mobilePickers>
                                            <div class="row g-2">
                                                <div class="col-6">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>Date</mat-label>
                                                        <input #mobileDateInput matInput type="date"
                                                               [value]="mobileDateValue"
                                                               (change)="onMobileDateChange($any($event.target).value)">
                                                    </mat-form-field>
                                                </div>
                                                <div class="col-6">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>Time</mat-label>
                                                        <input #mobileTimeInput matInput type="time"
                                                               step="900"
                                                               [value]="mobileTimeValue"
                                                               (change)="onMobileTimeChange($any($event.target).value)">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>

                                <app-schedule-conflicts *ngIf="!isRecurring"
                                #scheduleConflicts
                                [dateTime]="field_date_and_time"
                                [instructor]="f.value.field_instructor"
                                [lessonType]="f.value.field_type"
                                [duration]="f.value.field_duration"
                                [entityId]="entityId"
                                (dateTimeChange)="field_date_and_time = $event">
                              </app-schedule-conflicts>

                              <div *ngIf="outsideHoursWarning?.outside_hours"
                                   @slideFade
                                   class="alert alert-danger d-flex align-items-start mt-2 mb-0"
                                   role="alert">
                                <mat-icon class="me-2 flex-shrink-0" aria-hidden="true">warning</mat-icon>
                                <div class="flex-grow-1">
                                  <strong>Heads up: this is outside the studio's working hours.</strong>
                                  <div class="mt-1">{{ outsideHoursHeadline() }}</div>
                                  <div class="small mt-1">{{ outsideHoursHoursLine() }}</div>
                                  <div *ngIf="outsideHoursAmPmNudge() as nudge" class="small mt-1 text-muted">
                                    Double-check AM vs PM: {{ nudge }}
                                  </div>
                                  <div class="small mt-1 text-muted">
                                    You can still save if this is intentional.
                                  </div>
                                </div>
                                <button type="button"
                                        class="btn-close ms-2 flex-shrink-0"
                                        aria-label="Dismiss"
                                        (click)="dismissOutsideHoursWarning()"></button>
                              </div>

                            </div>

                            <div class="col-12" *ngIf="this.actionType === 'create'">
                                <app-standing-series
                                  [studentAccountId]="extractIdFromAutocomplete(field_student?.[0]?.field_student_account || '')"
                                  [instructorId]="field_instructor || ''"
                                  [duration]="f?.value?.field_duration || '00:45'"
                                  [time]="field_date_and_time ? (field_date_and_time | date:'HH:mm') : ''"
                                  [startDate]="field_date_and_time ? (field_date_and_time | date:'yyyy-MM-dd') : ''"
                                  [lessonType]="f?.value?.field_type || ''"
                                  [bundle]="bundle"
                                  [selectedEnrollment]="getEnrollmentById(f?.value?.__field_students_inline_form?.field_enrollment) || selectedEnrollmentForSeries"
                                  (recurrenceChanged)="onRecurrenceChanged($event)">
                                </app-standing-series>
                            </div>

                            <div class="col-12">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Notes</mat-label>
                                    <textarea ngModel name="field_notes" matInput placeholder=""></textarea>
                                </mat-form-field>
                            </div>

                            <div class="col-12">
                                <mat-checkbox
                                    [ngModel]="this._frmValues?.field_is_confirmed"
                                    name="field_is_confirmed"
                                    class="example-margin mb-3 mt-3">Confirmed</mat-checkbox>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-tab>

            <mat-tab label="Delete" [disabled]="this.initActionType == 'create'"
                *ngIf="this.actionType != 'create'">
                <app-entity-confirm-delete></app-entity-confirm-delete>
            </mat-tab>

        </mat-tab-group>

    </div>

</div>

<!-- <div *ngIf="f.form.invalid">
    <h3>Invalid Fields:</h3>
    <ul>
        <li *ngFor="let invalidControl of getInvalidControls(f)">
        {{ invalidControl.name }} - Error: {{ invalidControl.errors | json }}
        </li>
    </ul>
</div> -->

<mat-dialog-actions align="end">
    <ng-container *ngIf="this.actionType === 'create'">
        <button [disabled]="isSaving || (field_student?.length == 0 && !hasPendingAttendee()) || !f?.value?.field_type
                    || !f?.value?.field_instructor || !f?.value?.field_date_and_time
                    || studentAccountFormatError
                    || (isRecurring && (!recurrenceConfig || recurrenceConfig.days.length === 0))"
            type="button" (click)="onSubmit(f);" mat-raised-button
            color="primary">
            {{ isRecurring
               ? (isSaving ? 'Generating...' : 'Save & Generate Series')
               : (isSaving ? 'Saving...' : 'Save') }}
        </button>
    </ng-container>

    <!-- Conflict display for recurring save -->
    <div *ngIf="seriesConflicts?.length > 0" class="series-conflict-section" style="width: 100%; padding: 12px 0;">
        <div style="display: flex; align-items: center; gap: 8px; color: #c62828; margin-bottom: 8px;">
            <mat-icon>warning</mat-icon>
            <strong>{{ seriesConflicts.length }} conflict(s) found</strong>
        </div>
        <div style="max-height: 120px; overflow-y: auto; margin-bottom: 8px;">
            <div *ngFor="let c of seriesConflicts" style="font-size: 0.9em; padding: 2px 0; color: #555;">
                {{ c.date | date:'EEE, MMM d' }} &mdash; {{ c.message }}
            </div>
        </div>
        <div style="display: flex; gap: 8px;">
            <button mat-raised-button color="warn" [disabled]="isSaving"
                    (click)="generateIgnoringConflicts()">
                Generate Anyway
            </button>
            <button mat-raised-button [disabled]="isSaving"
                    (click)="cancelRecurringSave()">
                Cancel
            </button>
        </div>
    </div>
    <ng-container *ngIf="this.actionType === 'edit'">
        <ng-container *ngIf="this.initActionType == 'edit'">
            <button [disabled]="isEventLocked || isSaving" type="button"
                (click)="setFormMode('delete')" mat-raised-button color="accent">Delete</button>
            <button [disabled]="isEventLocked || studentAccountFormatError || isSaving" type="button"
                (click)="onSubmit(f);" mat-raised-button color="primary">{{ isSaving ? 'Saving...' : 'Save' }}</button>
        </ng-container>
        <ng-container *ngIf="this.initActionType == 'create'">
            <button type="button" (click)="closeDialog()" mat-raised-button
                color="accent">Cancel</button>
            <button [disabled]="studentAccountFormatError || isSaving" type="button" (click)="onSubmit(f);" mat-raised-button
                color="primary">{{ isSaving ? 'Saving...' : 'Save' }}</button>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="this.actionType === 'delete'">
        <button (click)="setFormMode('edit')" type="submit" mat-raised-button
            color="accent">Cancel</button>
        <button
            (click)="onDeleteSubmit(this._injectedDialogData['data']['EntityID'])"
            type="submit" mat-raised-button
            color="accent">Delete</button>
    </ng-container>
</mat-dialog-actions>
